/**
 * 上传 S3
 */

import React from 'react';
import { HelperCore } from '@/common/helper';
import { Upload } from 'antd';
import Request from "@src/common/request";

const uploadByQiNiu = (file) => {
  const params = HelperCore.getForm({
    up_file : file,
  });

  return Request.post("/image/upload", params, {
    dataIsForm : true,
  })
  .then(res => {
    return {
      data : {
        url : res.data.up_url,
      },
    }
  });
}

const UploadQiniu = ((props) => {
  const {
    className = '',
    children,
    accept="image/png,image/jpeg,image/jpg",
    onUpload = () => {},
    showUploadList,
    cropperOptions,
    ...uploadConfig
  } = props;

  const doUpload = (file) => {
    uploadByQiNiu(file)
    .then(res => {
      const { data } = res;
      const { url } = data;
      onUpload({
        error : null,
        url,
        file,
      });
    });
  }
  const customRequest = (event) => {
    const file = event.file;
    const { type } = file;

    doUpload(file);
  }

  return (
    <Upload
      className={`${className}`}
      showUploadList={showUploadList ?? false}
      accept={accept}
      customRequest={customRequest}
      {...uploadConfig}
      >
      {children}
    </Upload>
  )
});
export default UploadQiniu;